import React from 'react';
import { Switch, useRouteMatch, Redirect, Route } from 'react-router';

import { RESOURCES } from 'constants/urls';

import { LoansAndCreditResourcesPage } from './LoansAndCreditResourcesPage/LoansAndCreditResourcesPage';
import { RepayYourLoansEarlyPage } from './RepayYourLoansEarlyPage/RepayYourLoansEarlyPage';

const LoansAndCreditResourcesRouter = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route exact={true} path={match.path} component={LoansAndCreditResourcesPage} />
      <Route
        exact={true}
        path={RESOURCES.LOANS_AND_CREDIT.repayYourLoansEarlyPage}
        component={RepayYourLoansEarlyPage}
      />
      <Redirect to={match.path} />
    </Switch>
  );
};

export default LoansAndCreditResourcesRouter;
